


import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class TextFilterForm extends Vue {
    @Prop( { default: "" } )
    Value!: string;

    private internalValue: string = "";

    /* Timer du debounce de saisie. */
    private debounce: any = undefined;

    private created() {
        this.internalValue = this.Value;
    }

    private beforeDestroy() {
        if( this.debounce !== undefined )
            clearTimeout( this.debounce );
    }

    @Watch( "Value" )
    private onValueChange( value: string ) {
        this.internalValue = value;
    }

    @Watch( "internalValue" )
    private onInternalValueChange( value: string ) {
        /* Debounce 300ms : chaque émission déclenche une requête liste (Records). Sans délai, taper
           "facilogi" = 8 appels API. Aligné sur le debounce des Autocomplete V2. */
        if( this.debounce !== undefined )
            clearTimeout( this.debounce );

        this.debounce = setTimeout( () => {
            this.$emit( "Value", value );
        }, 300 );
    }
}
